












































































































































import {
  Employee,
  FavoriteCategories,
  FavoriteItem,
  FavoriteItems,
} from "@/api";
import { Component, Vue, Prop } from "vue-property-decorator";
import moment from "moment";
import { dateFormat } from "@/common/date_format";
import { checkOtherRole, checkSelf, checkSelfRole } from "@/common/role_utils";
import * as validation from "@/tool/validation";
import _ from "lodash";

@Component
export default class EditEmployee extends Vue {
  @Prop(Object) readonly employee!: Employee;
  @Prop() readonly id!: number;

  valid = true;
  firstName = this.employee.firstName;
  lastName = this.employee.lastName;
  title = this.employee.titleId;
  showDate = false;
  birthPicker = false;
  hireDate = this.employee?.hireDate?.substr(0, 10) || null;
  birthday = this.employee?.birthday?.substr(0, 10) || null;
  formattedBirthday = "";
  formattedhireDate = "";
  phone = this.employee.phone || null;
  about = this.employee.about;
  hobbies = this.employee.hobbies;
  shift = this.employee?.shift || 0;
  newDate = "";
  formErrors = "";
  isEmployee = checkSelfRole("employee");
  showBirthday = this.employee.birthdayVisible ? false : true;
  saving = false;

  nameRules = [
    validation.requiredString,
    (v: string) => validation.maxLen(v, 20),
    validation.noSpace,
  ];
  lNameRules = [(v: string) => validation.maxLen(v, 20), validation.noSpace];
  phoneRules = [validation.validatePhone];

  required_select = validation.requiredSelect;
  maxDate = new Date().toISOString().substr(0, 10);
  date_required = validation.requiredSelect;
  requiredShift = [validation.requriedNumber];
  userFavoriteItems: FavoriteItems = [];

  get isSelectedOwner() {
    return checkOtherRole(this.employee, "owner");
  }

  get isSelf() {
    return checkSelf(this.employee.id);
  }

  async created() {
    const dispatches: Promise<unknown>[] = [
      this.$store.dispatch(
        "departmentAdmin/getTitle",
        this.employee.primaryDepartmentId,
      ),
    ];
    if (!this.$store.getters["shift/shifts"]) {
      dispatches.push(this.$store.dispatch("shift/fetchShifts"));
    }
    await Promise.all(dispatches);
  }

  async save() {
    this.saving = true;
    const edit = this.$store.dispatch("directory/editEmployeeProfile", {
      requestBody: {
        firstName: this.firstName?.trim(),
        lastName: this.lastName?.trim(),
        hireDate: !this.hireDate ? null : new Date(this.hireDate).toISOString(),
        birthday: !this.birthday ? null : new Date(this.birthday).toISOString(),
        titleId: this.title,
        phone: !this.phone ? null : this.phone,
        about: this.about?.trim(),
        hobbies: this.hobbies?.trim(),
        shift: Number(this.shift),
        birthdayVisible: this.isSelf
          ? this.showBirthday
            ? 0
            : 1
          : this.employee.birthdayVisible,
      },
      employeeId: this.employee.id,
    });

    const populatedFavoriteItems = _.filter(
      this.userFavoriteItems || [],
      item => item.item,
    );

    const saveFavorite = this.$store.dispatch("directory/saveFavoriteItems", {
      employeeId: this.employee.id,
      requestBody: populatedFavoriteItems,
    });

    await Promise.all([edit, saveFavorite]);

    this.$store.dispatch(
      "directory/getTitledEmployee",
      this.$route.params.titleId,
    );

    this.saving = false;
    this.close();
  }
  close() {
    this.$emit("save");
  }
  formatDate(date: string, isBirthday: boolean) {
    if (isBirthday) this.formattedBirthday = dateFormat(date);
    else this.formattedhireDate = dateFormat(date);
  }
  selectedDate() {
    if (this.birthday && this.hireDate) {
      if (this.birthday < this.hireDate) {
        const indate = this.birthday.substr(0, 10);
        const hired = this.hireDate.substr(0, 10);
        const birthday = moment(indate);
        const currentdate = moment(hired);
        const duration = moment.duration(currentdate.diff(birthday));
        if (duration.years() > 13) {
          this.formErrors = "";
        } else {
          this.formErrors = "Must be 14 years old at least";
        }
      } else {
        this.formErrors = "birthday should not be greater than hire date";
      }
    }
  }
  get shifts() {
    return this.$store.getters["shift/shifts"] || [];
  }

  get titleList() {
    const list = this.$store.getters["departmentAdmin/departmentTitle"];
    if (list) {
      return list;
    } else {
      return [];
    }
  }

  get favoriteItems(): FavoriteItems {
    const categories =
      (this.$store.getters[
        "favoriteCategory/favoriteCategories"
      ] as FavoriteCategories) || [];
    const favoriteItems = this.$store.getters["directory/favoriteItems"];

    const res = _.map(categories, category => {
      const items = _.find(
        favoriteItems || [],
        item => item.category?.id === category.id,
      );
      if (items) {
        return {
          ...items,
        } as FavoriteItem;
      } else {
        return {
          id: 0,
          category: {
            id: category.id,
            name: category.category,
          },
          employee: {
            id: this.employee.id,
            name: `${this.employee.firstName} ${this.employee.lastName}`,
          },
          item: "",
        } as FavoriteItem;
      }
    });
    this.userFavoriteItems = JSON.parse(JSON.stringify(res));
    return favoriteItems;
  }
}
